import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50 mt-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <h3 className="text-lg font-heading font-bold mb-3">泷泽萝拉</h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              日本知名写真偶像与女演员，本网站致力于为粉丝提供泷泽萝拉最全面、最权威的个人资料、作品信息与最新动态。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold mb-4 text-background-50/80">快速导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category/profile" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">个人资料</Link>
              </li>
              <li>
                <Link to="/category/works" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">作品全集</Link>
              </li>
              <li>
                <Link to="/category/photobook" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">写真集</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold mb-4 text-background-50/80">更多内容</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/news" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">最新动态</Link>
              </li>
              <li>
                <Link to="/category/debut" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">出道经历</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">关于本站</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold mb-4 text-background-50/80">友情链接</h4>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors" rel="nofollow">日本写真协会</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors" rel="nofollow">娱乐新闻速报</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors" rel="nofollow">写真收藏指南</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-700/40 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 泷泽萝拉官方资料站. All rights reserved.
          </p>
          <p className="text-xs text-foreground-500">
            本站为非官方粉丝资讯网站，所有内容仅供信息参考
          </p>
        </div>
      </div>
    </footer>
  );
}